import { useEffect, useState } from "react"
import { api, errorText } from "../api/client"
import { Brand } from "./SignIn"

const KEY = "walkie.invite"

/**
 * Called once at startup: moves an invitation code out of the URL fragment
 * (so it never lands in history, referrers or server logs) into this tab's
 * session until it is accepted.
 */
export function captureInviteFromHash() {
	if (location.pathname !== "/join") return
	const code = decodeURIComponent(location.hash.replace(/^#/, "")).trim()
	if (code) {
		try {
			sessionStorage.setItem(KEY, code)
		} catch {
			/* ignore */
		}
		history.replaceState(null, "", "/join")
	}
}

export function JoinPage() {
	const [err, setErr] = useState<string | null>(null)
	const [done, setDone] = useState(false)
	useEffect(() => {
		let code: string | null = null
		try {
			code = sessionStorage.getItem(KEY)
		} catch {
			code = null
		}
		if (!code) return setErr("This invitation link is incomplete. Ask for a new one.")
		api
			.acceptInvite(code)
			.then(r => {
				sessionStorage.removeItem(KEY)
				setDone(true)
				setTimeout(() => location.replace(r.projectId ? `/p/${r.projectId}` : "/"), 700)
			})
			.catch(e => setErr(errorText(e)))
	}, [])
	return (
		<div className="page">
			<div className="card">
				<div className="card-h">
					<Brand />
					<span className="dim">· invitation</span>
				</div>
				{err ? (
					<>
						<div className="form-error" role="alert">
							{err}
						</div>
						<a
							className="btn"
							href="/"
							style={{ justifyContent: "center", textDecoration: "none" }}
						>
							Open Walkie
						</a>
					</>
				) : done ? (
					<div style={{ color: "var(--ok)" }}>✓ You're in. Opening the project…</div>
				) : (
					<div className="loading-bar" />
				)}
			</div>
		</div>
	)
}
